'use strict';

angular.module('far.models.insuranceApplication', [])
.service('insuranceApplication', function ($log, $http) {
    this.new = function (applicationData) {
        return new InsuranceApplication(applicationData);
    };

    function InsuranceApplication(applicationData) {
        var persons = [];

        angular.merge(this, applicationData);

        if (angular.isUndefined(this.persons_list)) {
            Object.defineProperty(this, 'persons_list', {
                enumerable: true,
                set: function(data) {
                    data.forEach(function(person) {
                        persons.push(person);
                    });
                },
                get: function() {
                    return persons;
                }
            });
        }

        Object.defineProperty(this, 'update', {
            enumerable: false,
            get: function() {
                return function(applicationData) {
                    angular.merge(this, applicationData);
                }
            }
        });

        Object.defineProperty(this, 'save', {
            enumerable: false,
            get: function() {
                return function() {
                    var method = 'post',
                        url = Routing.generate('api_post_insurance_application');

                    var data = angular.merge({}, this);

                    // Для формы 3 типа в поле суммы сливаем 2 значения
                    if (angular.isDefined(data.insurance_sum1)) {
                        data.insurance_sum = data.insurance_sum1.name + ' (Е-экстрим) + ' + data.insurance_sum2.name + ' (от НС)';
                        delete data.insurance_sum1;
                        delete data.insurance_sum2;
                    }
                    // Для форм 1 и 2 типов - просто берем выбранное значение
                    else {
                        data.insurance_sum = data.insurance_sum.name;
                    }

                    if (angular.isDefined(data.sport_kinds)) {
                        data.sport_kinds = data.sport_kinds.name;
                    }
                    data.submit_time = new Date();
                    data.persons = data.persons_list;
                    delete data.persons_list;
                    
                    return $http[method](url, data);
                }
            }
        });

    } // function InsuranceApplication

});